"use client";
import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { useLocaleText as p, Group as _, Avatar as f, Paragraph as o } from "@ingeniorforeningen/figurine-core";
import { forwardRef as g } from "react";
import { serialCommaSentence as l } from "../SingleTrackProgram.helpers.js";
import '../../../../assets/SingleTrackProgramProgramContributor.css';const h = "_multipleContainer_e0oid_4", C = "_meta_e0oid_12", v = "_name_e0oid_20", x = "_title_e0oid_26", N = "_avatar_e0oid_39", a = {
  multipleContainer: h,
  meta: C,
  name: v,
  title: x,
  avatar: N
}, i = g(
  (m, c) => {
    const { contributors: t, ...d } = m, n = p();
    if (t.length === 0) return null;
    const u = t.length === 1 ? {
      src: {
        src: t[0].src?.src ?? void 0,
        alt: t[0].src?.alt || ""
      }
    } : {
      src: t.map((e) => ({
        src: e.src?.src ?? void 0,
        alt: e.src?.alt || ""
      }))
    };
    return /* @__PURE__ */ s(
      _,
      {
        ...d,
        className: t.length > 1 ? a.multipleContainer : void 0,
        align: "start",
        ref: c,
        children: [
          t.length && t.length <= 2 && /* @__PURE__ */ r(f, { size: "md", className: a.avatar, ...u }),
          /* @__PURE__ */ s("div", { className: a.meta, children: [
            /* @__PURE__ */ r(
              o,
              {
                text: l(
                  t.map((e) => e.name),
                  n.and
                ),
                className: a.name
              }
            ),
            /* @__PURE__ */ r(
              o,
              {
                text: l(
                  t.map((e) => e.title),
                  n.and
                ),
                className: a.title
              }
            )
          ] })
        ]
      }
    );
  }
);
i.displayName = "ProgramContributor";
const S = i;
export {
  i as _ProgramContributor,
  S as default
};
